import React from 'react';
import { Flex } from 'antd';
import { formatDateTime } from 'shared/utils/time/format-date-time';
import { ClientFinancialTag } from 'components/clients/client-financial-tag';
import { CardUi } from 'components/common/card-ui';
import type { IOrderInfoCardProps } from 'components/orders/order-info-card/types';

export const OrderInfoCard: React.FC<IOrderInfoCardProps> = (props) => {
  const { order, client } = props;

  return (
    <CardUi>
      <Flex align='start' gap='small' vertical>
        <ClientFinancialTag
          paymentPeriod={order.paymentPeriod}
          paymentTerms={order.paymentTerms}
          clientPaymentTerms={client.paymentTerms}
          clientPaymentPeriod={client.paymentPeriod}
        />
        <div>
          <strong>Created:</strong> {formatDateTime(order.createdAt)}
        </div>
        <div>
          <strong>Manager:</strong> {order.user.name}
        </div>
      </Flex>
    </CardUi>
  );
};
